// Type any is fine in highly generic utils
/* eslint-disable @typescript-eslint/no-explicit-any */

export const tryPromise = async <D>(
  promiseFn: (...args: any[]) => Promise<D>,
): Promise<{ data?: D; error?: Error }> => {
  try {
    const data = await promiseFn();

    return {
      data: data,
    };
  } catch (error: unknown) {
    if (error instanceof Error) return {
      error: error,
    };

    return {
      error: new Error('Unknown error'),
    };
  }
};

export const tryFn = <D>(fn: (...args: any) => D): { data?: D; error?: Error } => {
  try {
    const data: D = fn();

    return {
      data: data,
    };
  } catch (error: unknown) {
    if (error instanceof Error) return {
      error: error,
    };

    return {
      error: new Error('Unknown error'),
    };
  }
};

/**
 * Unwrap a settled promise result.
 *
 * Used for Promise.allSettled results. Call it using individual settled results.
 *
 * @example
 * const dataPromises = [fetchData1(), fetchData2()] as const;
 * const settledResult = await Promise.allSettled(dataPromises);
 * const { data, error } = unwrapSettledResult(settledResult[0]);
 */
export const unwrapSettledResult = <D>(
  settledResult: PromiseSettledResult<D>,
): {
  data?: D;
  error?: Error;
} => {
  if (settledResult.status === 'fulfilled') return {
    data: settledResult.value,
  };

  if (settledResult.status === 'rejected') {
    if (settledResult.reason instanceof Error) return {
      error: settledResult.reason,
    };

    return {
      error: new Error('Unknown error'),
    };
  }

  return {};
};
